import { Component, OnInit, Input, ViewChild } from '@angular/core';

import {
  NgbDateStruct,
  NgbModal,
  NgbActiveModal,
} from '@ng-bootstrap/ng-bootstrap';

import { MeetingagendacomplianceComponent } from '../meetingagendacompliance/meetingagendacompliance.component';
import { MeetingMasterService } from '../../../services/meetingMaster.service';
import { environment } from '../../../../environments/environment';

import * as _ from 'lodash';

declare var $: any;
declare var jQuery: any;

import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-meetingagendaview',
  templateUrl: './meetingagenda.component.html',
  styleUrls: ['./meetingagenda.component.css'],
})
export class MeetingAgendaViewComponent implements OnInit {
  @Input('agendaObject') agendaObject: any;
  @Input('meetingObjectView') meetingObject: any;

  agendaCompliances: any;
  isAgendaObjectEmpty: boolean;

  @ViewChild(DataTableDirective)
  dtElementAgendaCompliancePopUp: DataTableDirective;
  dtOptionsOfAgendaCompliancePopUp: DataTables.Settings = {};
  dtTriggerAgendaCompliancePopUp: Subject<any> = new Subject();

  agendaPdfIsAvailable: any;
  agendaUplaodedPdfID: any;
  agendaGenerationTitle: any;
  agendaGenerationID: any;
  AgendaFile: any;
  AgendaTitlePdf: any;
  AgendaNumberPdf: any;
  
  // Voting properties
  agendaVotes: any = {};
  votingLoading: any = {};
  votingError: any = {};
  isAdmin = false;
  currentUserId = '';
  agendaEligibleUserIds: { [agendaId: string]: Set<string> } = {};
  meetingParticipants: Array<{ userId: string; userName: string; userEmail: string; participantType: string }> = [];
  selectedAgendaForEligibility: any = null;
  eligibilitySaving = false;
  
  constructor(
    private router: Router, 
    private modalService: NgbModal, 
    public activeModal: NgbActiveModal,
    private meetingMasterService: MeetingMasterService,
  ) { }

  ngOnInit() {
    this.resolveCurrentUserAndRoles();
    this.meetingParticipants = this.buildMeetingParticipants();
    if (_.size(this.agendaObject)) {

     
      this.agendaObject = _.sortBy(this.agendaObject, (o) => o.Agendaorder);
      this.agendaObject = this.agendaObject.map(function (item) {
        var o = Object.assign({}, item);

        o.fileType = item.AgendaGenerationPdf.map(function (subItem) {
          var oSub = Object.assign({}, subItem);
          oSub = subItem.UploadFileName.slice(-3);

          return oSub;
        });

        return o;
      });
      console.log('this.agendaObject', this.agendaObject);

      this.isAgendaObjectEmpty = false;
      
      // Load vote summaries for all agendas
      this.loadAllAgendaVotes();
    } else {
      this.isAgendaObjectEmpty = true;
    }

    //   $(document).on('show.bs.modal', '.modal', function () {
    //     var zIndex = 1040 + (10 * $('.modal:visible').length);
    //     $(this).css('z-index', zIndex);
    //     setTimeout(function() {
    //         $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
    //     }, 0);
    // });

    this.dtOptionsOfAgendaCompliancePopUp = {
      destroy: true,
      scrollY: '400px',
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      search: true,
      order: [1, 'asc'],
      columnDefs: [{ orderable: false, targets: [0, 1, 2, 3] }],
      lengthMenu: [
        [5, 10, 25, 50, 100, -1],
        [5, 10, 25, 50, 100, 'All'],
      ],
    };

    // console.log("agendaObject-modal",this.agendaObject);
  }

  agendasCompliancepopUpDataToShow(agenda) {
    const modalRef = this.modalService.open(MeetingagendacomplianceComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.agendaComplianceObject = agenda.AgendaCompliance;

    modalRef.result
      .then(
        (response) => {
          // console.log("response", response);
        },
        (error) => {
          // console.log("modal agenda compliance", error)
        }
      )
      .catch((error) => {
        // console.log("Catch Error", error)
      });
    // var agendaCompliancePopUpTable = $('#agendaCompliancePopUpTable').DataTable({destroy : true}).destroy();

    // console.log("agendaDetailsObject",agenda);
    // if(agenda.AgendaCompliance == undefined || agenda.AgendaCompliance == []){
    //   this.agendaCompliances = [];
    // }else if(agenda.AgendaCompliance.length > 0 ){
    //   this.agendaCompliances = agenda.AgendaCompliance
    // }
    // this.dtTriggerAgendaCompliancePopUp.next()
  }

  initiateUploadAgendaPdf(data) {
    this.AgendaTitlePdf = data.AgendaTitle;
    this.AgendaNumberPdf = data.AgendaNumber;
    this.agendaPdfIsAvailable = data.AgendaGenerationPdf.IsPdfAvailable;
    this.agendaUplaodedPdfID = data.AgendaGenerationPdf.DocumentManagementID;
    this.agendaGenerationTitle = data.AgendaTitle;
    this.agendaGenerationID = data._id;

    this.AgendaFile = data.AgendaGenerationPdf.map(element => {
      var o = Object.assign({}, element)
      o.FileType = (element.PdfName).substr(-3)
      return o;
    })

    $("#AgendaPdfUploadTitle").html(this.AgendaTitlePdf);
    $("#AgendaNum").html(this.AgendaNumberPdf);
    $("#agendaPdfUploadDialog").modal('toggle');
  }

  downloadDocumentFile(fileID, fileType) {
    console.error('sklog> fileTypefileType', fileType);
    if (fileType == 'PDF' || fileType == 'pdf') {
      console.log("meetingagendacomponent-view")
      $('#myModalForDocument').data('modal', null);
      this.meetingMasterService
        .getAttendanceFileName(fileID)
        .then((response) => {
          var url =
            environment.PSSFileurl +
            '/Document_Type/' +
            response.data.Filename +
            '#toolbar=0';
          console.log(
            'response',
            environment.PSSFileurl + '/Document_Type/' + response.data.Filename
          );

          // url = encodeURIComponent(url)
          // var newurl = "/#/pdfviewer/" + url + '/' + this.meetingObject._id + '/' + fileID + '/' + btoa(response.data.OriginalFileName)
          console.error('sklog> fileTypefileType', url);
          window.open(url, '_blank');

          // this.router.navigate([
          //   'pdfviewer',
          //   url,
          //   this.meetingObject._id,
          //   fileID,
          //   btoa(response.data.OriginalFileName),
          // ]);
        });
    } else {
      this.meetingMasterService.getAttendanceFile(fileID);
    }
  }

  // Voting Methods
  
  /**
   * Load vote summaries for all agendas
   */
  loadAllAgendaVotes() {
    if (!this.meetingObject || !this.meetingObject._id) {
      return;
    }

    this.agendaObject.forEach(agenda => {
      if (agenda.isPublished && agenda._id) {
        this.loadAgendaVote(agenda._id);
      }
    });
  }

  /**
   * Load vote summary for a specific agenda
   */
  loadAgendaVote(agendaID: string) {
    this.votingLoading[agendaID] = true;
    this.votingError[agendaID] = null;

    this.meetingMasterService
      .getAgendaVoteSummary(this.meetingObject._id, agendaID)
      .then((response) => {
        this.votingLoading[agendaID] = false;
        if (response != null && response.status == 0) {
          this.agendaVotes[agendaID] = response.data;
          const eligible = Array.isArray(response?.data?.eligibleUserIds)
            ? response.data.eligibleUserIds
            : [];
          if (eligible.length > 0) {
            this.agendaEligibleUserIds[agendaID] = new Set(
              eligible.map((x: any) => String(x).trim()).filter(Boolean)
            );
          }
          this.loadAgendaEligibility(agendaID);
        } else {
          this.votingError[agendaID] = 'Failed to load votes';
          console.error('Error loading votes:', response);
        }
      })
      .catch((error) => {
        this.votingLoading[agendaID] = false;
        this.votingError[agendaID] = 'Failed to load votes';
        console.error('Error loading votes:', error);
      });
  }

  /**
   * Submit a vote for an agenda
   */
  submitVote(agenda: any, voteType: string) {
    if (!this.meetingObject || !this.meetingObject._id || !agenda._id) {
      alert('Invalid meeting or agenda');
      return;
    }
    if (!this.canCurrentUserVoteAgenda(agenda._id)) {
      alert('You are currently not eligible to vote on this agenda.');
      return;
    }

    // Confirm action
    const action = voteType === 'APPROVE' ? 'approve' : 'reject';
    if (!confirm(`Are you sure you want to ${action} this agenda?`)) {
      return;
    }

    this.votingLoading[agenda._id] = true;
    this.votingError[agenda._id] = null;

    const voteData = {
      MeetingID: this.meetingObject._id,
      AgendaID: agenda._id,
      AgendaNumber: agenda.AgendaNumber,
      AgendaTitle: agenda.AgendaTitle,
      VoteType: voteType,
      Comments: null
    };

    this.meetingMasterService
      .submitAgendaVote(voteData)
      .then((response) => {
        this.votingLoading[agenda._id] = false;
        if (response != null && response.status == 0) {
          // Reload vote summary to get updated counts
          this.loadAgendaVote(agenda._id);
          
          // Show success message
          const message = voteType === 'APPROVE' 
            ? 'Your approval has been recorded successfully!' 
            : 'Your rejection has been recorded successfully!';
          alert(message);
        } else {
          this.votingError[agenda._id] = response.message || 'Failed to submit vote';
          alert('Failed to submit vote: ' + this.votingError[agenda._id]);
        }
      })
      .catch((error) => {
        this.votingLoading[agenda._id] = false;
        this.votingError[agenda._id] = 'Failed to submit vote';
        alert('Error submitting vote. Please try again.');
        console.error('Error submitting vote:', error);
      });
  }

  /**
   * Retract/delete user's vote
   */
  retractVote(agendaID: string) {
    if (!confirm('Are you sure you want to retract your vote?')) {
      return;
    }

    this.votingLoading[agendaID] = true;
    this.votingError[agendaID] = null;

    this.meetingMasterService
      .retractAgendaVote(this.meetingObject._id, agendaID)
      .then((response) => {
        this.votingLoading[agendaID] = false;
        if (response != null && response.status == 0) {
          // Reload vote summary
          this.loadAgendaVote(agendaID);
          alert('Your vote has been retracted successfully!');
        } else {
          this.votingError[agendaID] = response.message || 'Failed to retract vote';
          alert('Failed to retract vote: ' + this.votingError[agendaID]);
        }
      })
      .catch((error) => {
        this.votingLoading[agendaID] = false;
        this.votingError[agendaID] = 'Failed to retract vote';
        alert('Error retracting vote. Please try again.');
        console.error('Error retracting vote:', error);
      });
  }

  /**
   * Get user's current vote for an agenda
   */
  getUserVote(agendaID: string) {
    return this.agendaVotes[agendaID]?.userVote;
  }

  /**
   * Check if user has voted
   */
  hasUserVoted(agendaID: string): boolean {
    return !!this.getUserVote(agendaID);
  }

  /**
   * Get vote counts for an agenda
   */
  getVoteCounts(agendaID: string) {
    return {
      approveCount: this.agendaVotes[agendaID]?.approveCount || 0,
      rejectCount: this.agendaVotes[agendaID]?.rejectCount || 0,
      totalVotes: this.agendaVotes[agendaID]?.totalVotes || 0
    };
  }

  private resolveCurrentUserAndRoles(): void {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      this.currentUserId = String(user?._id || '').trim();
      const roles = Array.isArray(user?.Roles)
        ? user.Roles.map((r) => String(r?.RoleName || '').trim())
        : [];
      this.isAdmin = roles.includes('Admin') || roles.includes('All Role');
    } catch {
      this.currentUserId = '';
      this.isAdmin = false;
    }
  }

  private buildMeetingParticipants(): Array<{ userId: string; userName: string; userEmail: string; participantType: string }> {
    const meeting = this.meetingObject || {};
    const directors = Array.isArray(meeting?.Directors) ? meeting.Directors : [];
    const members = Array.isArray(meeting?.Members) ? meeting.Members : [];
    const mapRows = (rows: any[], participantType: string) =>
      rows
        .map((r: any) => {
          const userId = String(r?.UserGovevaId || r?.userId || r?._id || '').trim();
          const userName = String(r?.Name || `${r?.FirstName || ''} ${r?.LastName || ''}` || r?.EmailId || '—').trim();
          const userEmail = String(r?.EmailId || r?.email || '').trim();
          return { userId, userName: userName || '—', userEmail, participantType };
        })
        .filter((x: any) => !!x.userId);
    const combined = [...mapRows(directors, 'Director'), ...mapRows(members, 'Member')];
    const unique = new Map<string, any>();
    combined.forEach((p) => {
      if (!unique.has(p.userId)) {
        unique.set(p.userId, p);
      }
    });
    return Array.from(unique.values());
  }

  private defaultEligibleSet(): Set<string> {
    return new Set(this.meetingParticipants.map((p) => p.userId));
  }

  loadAgendaEligibility(agendaID: string): void {
    if (!this.meetingObject?._id || !agendaID) {
      return;
    }
    this.meetingMasterService
      .getAgendaVoteEligibility(this.meetingObject._id, agendaID)
      .then((res: any) => {
        const data = res?.data ?? res?.result ?? res ?? {};
        const ids = Array.isArray(data?.eligibleUserIds) ? data.eligibleUserIds : [];
        if (ids.length > 0) {
          this.agendaEligibleUserIds[agendaID] = new Set(ids.map((x: any) => String(x).trim()).filter(Boolean));
        } else if (!this.agendaEligibleUserIds[agendaID]) {
          this.agendaEligibleUserIds[agendaID] = this.defaultEligibleSet();
        }
      })
      .catch(() => {
        if (!this.agendaEligibleUserIds[agendaID]) {
          this.agendaEligibleUserIds[agendaID] = this.defaultEligibleSet();
        }
      });
  }

  canCurrentUserVoteAgenda(agendaID: string): boolean {
    if (!this.currentUserId) {
      return true;
    }
    const eligible = this.agendaEligibleUserIds[agendaID];
    if (!eligible || eligible.size === 0) {
      return true;
    }
    return eligible.has(this.currentUserId);
  }

  openVoterEligibilityModal(agenda: any): void {
    if (!agenda?._id) {
      return;
    }
    this.selectedAgendaForEligibility = agenda;
    if (!this.agendaEligibleUserIds[agenda._id]) {
      this.agendaEligibleUserIds[agenda._id] = this.defaultEligibleSet();
      this.loadAgendaEligibility(agenda._id);
    }
    $('#agendaVoteEligibilityModal').modal('show');
  }

  isAgendaParticipantEligible(userId: string): boolean {
    const agendaId = this.selectedAgendaForEligibility?._id;
    if (!agendaId) {
      return false;
    }
    const eligible = this.agendaEligibleUserIds[agendaId];
    if (!eligible || eligible.size === 0) {
      return true;
    }
    return eligible.has(String(userId || '').trim());
  }

  toggleAgendaParticipantEligibility(userId: string): void {
    const agendaId = this.selectedAgendaForEligibility?._id;
    if (!agendaId) {
      return;
    }
    const uid = String(userId || '').trim();
    if (!uid) {
      return;
    }
    if (!this.agendaEligibleUserIds[agendaId]) {
      this.agendaEligibleUserIds[agendaId] = this.defaultEligibleSet();
    }
    if (this.agendaEligibleUserIds[agendaId].has(uid)) {
      this.agendaEligibleUserIds[agendaId].delete(uid);
    } else {
      this.agendaEligibleUserIds[agendaId].add(uid);
    }
    this.agendaEligibleUserIds[agendaId] = new Set(this.agendaEligibleUserIds[agendaId]);
  }

  saveAgendaEligibility(): void {
    const agendaId = this.selectedAgendaForEligibility?._id;
    if (!this.isAdmin || !this.meetingObject?._id || !agendaId) {
      return;
    }
    this.eligibilitySaving = true;
    const eligibleUserIds = Array.from(this.agendaEligibleUserIds[agendaId] || []);
    this.meetingMasterService
      .updateAgendaVoteEligibility(this.meetingObject._id, agendaId, { eligibleUserIds })
      .then((res: any) => {
        this.eligibilitySaving = false;
        if (res != null && res.status == 0) {
          alert('Agenda voting eligibility updated successfully.');
          $('#agendaVoteEligibilityModal').modal('hide');
          this.loadAgendaVote(agendaId);
          return;
        }
        alert(res?.message || 'Failed to update agenda voting eligibility.');
      })
      .catch(() => {
        this.eligibilitySaving = false;
        alert('Failed to update agenda voting eligibility.');
      });
  }
}
